export default __webpack_public_path__ + "static/media/dummy_dmv.08e7e227.png";